import {
  selectAppliedOffers,
  selectCartEntriesIdsMap,
  selectCmsOffers,
  selectCmsOffersMapByLoyaltyId,
  selectDiscountAppliedCmsOffers,
  selectIncentiveErrorsFilteredByCode,
  selectIncentiveErrorsWithCode,
  selectOfferFeedbackMap,
  selectOffers,
  selectOffersLoading,
  selectPersonalizedOffers,
  selectSelectedOffer,
  selectSurpriseAvailable,
  selectUpsizeAvailable,
  selectUserOffers,
} from './offers/offers.selectors';
import {
  selectAppliedLoyaltyRewards,
  selectAppliedLoyaltyRewardsArray,
  selectAppliedPoints,
  selectAvailableLoyaltyRewardsMap,
  selectIsPricingRewardApplication,
  selectStagedCartPoints,
  selectTotalTimesRewardApplied,
} from './rewards/rewards.selectors';
import { selectUser } from './user/user.selectors';

export const loyaltySelectors = {
  // Offer actions
  selectAppliedOffers,
  selectCartEntriesIdsMap,
  selectCmsOffers,
  selectCmsOffersMapByLoyaltyId,
  selectIncentiveErrorsFilteredByCode,
  selectIncentiveErrorsWithCode,
  selectOfferFeedbackMap,
  selectOffers,
  selectOffersLoading,
  selectPersonalizedOffers,
  selectSelectedOffer,
  selectSurpriseAvailable,
  selectUpsizeAvailable,
  selectUserOffers,
  selectDiscountAppliedCmsOffers,
  // Rewards actions
  selectAppliedLoyaltyRewards,
  selectAppliedLoyaltyRewardsArray,
  selectAppliedPoints,
  selectAvailableLoyaltyRewardsMap,
  selectIsPricingRewardApplication,
  selectStagedCartPoints,
  selectTotalTimesRewardApplied,
  // User actions
  selectUser,
};
